import { useTranslation } from "react-i18next"
import { getDocumentLabel, TYPES_DOCUMENTOS } from "../../constant"
import { FormikDocumentsProps } from "../../CreacionDocumento"
import CardAdjuntarArchivoDocumentoSetting from "./Components/CardAdjuntarArchivoDocumentoSetting/CardAdjuntarArchivoDocumentoSetting"
import CardColorDocumentoSetting from "./Components/CardColorDocumentoSetting/CardColorDocumentoSetting"
import { CardEtiquetasSetting } from "./Components/CardEtiquetasSetting/CardEtiquetasSetting"
import CardNuevosCamposDocumentosSetting from "./Components/CardNuevosCamposDocumentosSetting/CardNuevosCamposDocumentosSetting"
import CuentaContableDocumentoSetting from "./Components/CuentaContableDocumentoSetting/CuentaContableDocumentoSetting"

const CardConfiguracionDocumento = ({
  values,
  setFieldValue,
  errors,
  touched,
  handleChange,
}: FormikDocumentsProps) => {
  const { t } = useTranslation()
  return (
    <div className='w-full tw-flex tw-flex-col tw-h-full tw-text-left tw-border-neutral-25'>
      <p className='tw-m-0 tw-text-left tw-font-medium tw-text-xl tw-mb-3'>
        {t("crear.facturaRec.customDocument")}
        {getDocumentLabel(values.documentoType.type, t)}
      </p>
      {values.documentoType.type === TYPES_DOCUMENTOS.FACTURA && (
        <CuentaContableDocumentoSetting
          values={values}
          setFieldValue={setFieldValue}
          errors={errors}
          touched={touched}
          handleChange={handleChange}
        />
      )}
      {/*
      //TODO: Descomentar si en algun momento se pueden usar divisas diferentes al euro.
      <CardDivisaDocumentoSetting
        values={values}
        setFieldValue={setFieldValue}
      /> */}
      {values.documentoType.type === TYPES_DOCUMENTOS.FACTURA && (
        <CardEtiquetasSetting
          values={values}
          setFieldValue={setFieldValue}
        />
      )}
      {values.documentoType.type !== TYPES_DOCUMENTOS.PROFORMA && (
        <CardColorDocumentoSetting
          values={values}
          setFieldValue={setFieldValue}
        />
      )}
      <CardNuevosCamposDocumentosSetting
        values={values}
        setFieldValue={setFieldValue}
      />
      {values.documentoType.type !== TYPES_DOCUMENTOS.PROFORMA && (
        <CardAdjuntarArchivoDocumentoSetting
          values={values}
          setFieldValue={setFieldValue}
        />
      )}
    </div>
  )
}

export default CardConfiguracionDocumento
